<template>

<component-module moduleName="range_memberships_module">
    <template v-if="showFlightDeckHeader" v-slot:programName>Range &amp; Memberships</template>
    <template v-if="showFlightDeckHeader" v-slot:navigation>
        <div class="main-nav">
            <template v-if="dashboardMenuItem">
                <div v-if="dashboardMenuItem.not_allowed" class="not-allowed">Dashboard</div>
                <router-link v-else class="link" :to="'/' + dashboardMenuItem.link_value">Dashboard</router-link>
            </template>
            <template v-for="(menuItem, index) in mainMenu">
                <div v-if="menuItem.not_allowed" class="not-allowed" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</div>
                <router-link v-else class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
        <div class="secondary-nav">
            <div class="secondary-nav-title"><i class="fas fa-users"></i> Memberships</div>
            <template v-for="(menuItem, index) in memberships">
                <router-link class="link" :to="(menuItem.link_type == 'LEGACY' ? '/legacy/' : '') + menuItem.link_value" :key="'sub-menu-item-' + menuItem.menu_item_id">{{ menuItem.menu_label }}</router-link>
            </template>
        </div>
    </template>
</component-module>

</template>

<script>
import './range_memberships.scss'
export default {
    created() {
        this.updateCustomModuleName('Range & Memberships');
    },
    computed: {
        showFlightDeckHeader() {
            if (this.getUser.user_type_code == 'POS_CASHIER') {
                return false
            }
            return true
        },
        memberships() {
            if (!this.getModuleNavMenu.sort_1) return {}
            return this.getModuleNavMenu.sort_1.menu_items
        },
        mainMenu() {
            if (!this.getModuleNavMenu.sort_0) return {}
            return this.getModuleNavMenu.sort_0.menu_items
        },
        dashboardMenuItem() {
            for (const [key, menuItem] of Object.entries(this.getFlightDeckMainMenu)) {
                if (menuItem.link_value == 'range-memberships') {
                    return menuItem
                }
            }
        }
    }
}
</script>

<style>

</style>
